import { Component, ViewChild, Input, inject } from '@angular/core';

import {
  StripeService,
  StripeCardNumberComponent,
  StripeCardGroupDirective,
  StripeCardExpiryComponent,
  StripeCardCvcComponent,
} from 'ngx-stripe';
import { StripeCardElementOptions, StripeElementsOptions, PaymentMethod } from '@stripe/stripe-js';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';

@Component({
    selector: 'pxw-stripe-payment',
    templateUrl: './stripe-payment.component.html',
    styleUrls: ['./stripe-payment.component.scss'],
    imports: [
        StripeCardGroupDirective,
        StripeCardNumberComponent,
        StripeCardExpiryComponent,
        StripeCardCvcComponent,
        AlertComponent,
    ]
})
export class StripePaymentComponent {
  @Input() billingName = '';

  @ViewChild(StripeCardNumberComponent) card: StripeCardNumberComponent | undefined;

  error: string | null = null;

  cardOptions: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: 'Roboto, Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'es',
  };

  private stripeService = inject(StripeService);

  constructor() {}

  async createPaymentMethod(): Promise<PaymentMethod | undefined> {
    this.error = null;

    if (!this.card) {
      this.error = 'Error creating payment form';

      return Promise.reject(this.error);
    }

    const result = await this.stripeService
      .createPaymentMethod({
        type: 'card',
        card: this.card.element,
        billing_details: {
          name: this.billingName,
        },
      })
      .toPromise();

    if (result.error) {
      this.error = result.error.message || null;

      return Promise.reject(result.error);
    }

    return result.paymentMethod;
  }
}
